import type { NextPageContext } from 'next';
import cookies from 'nookies';

const doubleQuoteRegex = /"/g;
export const parseId = (str: string): string =>
    str.replace(doubleQuoteRegex, '');

export const ANON_ID_COOKIE_NAME = 'ajs_anonymous_id';

/**
 * Retrieve the anonId (ajs_anonymous_id cookie) from either client or server.
 *
 * If user has already visited the site and an anonId cookie is set then
 * read the cookie (from either request context for SSR or client document for
 * static pages)
 *
 * middleware.ts will generate a Set-Cookie header for anonid and also update
 * the request Cookie header with the same value
 *
 */
export function getAnonId(ctx: Pick<NextPageContext, 'req' | 'res'> | null) {
    const allCookies = cookies.get(ctx);
    const existingAnonId = allCookies[ANON_ID_COOKIE_NAME];

    if (existingAnonId) {
        return parseId(existingAnonId);
    }

    return;
}
